import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/international-luggage-shipping.jpg'),
    alt: 'international luggage shipping page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'international luggage shipping page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Secure <span>International</span><span>Luggage Shipping Services</span>',
  description:
    'Ship your luggage across the globe with ease and security. We offer fast, reliable, and affordable international luggage shipping solutions.',
  image: {
    url: '/images/v2/pages/landing-pages/international-luggage-shipping/hero-image.jpg',
    alt: 'Secure International Luggage Shipping Services'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for International Luggage Shipping' }
}

export const ourProcessSectionContent = {
  title: 'Fast International Luggage Shipping Solutions',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/international-luggage-shipping/fast-international-luggage-shipping-solutions.png',
    alt: 'Fast International Luggage Shipping Solutions'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Booking',
      description:
        'Book your international luggage shipping easily online or via our support team. Whether shipping one bag or multiple items, our platform ensures a smooth experience.',
      image: {
        src: '/images/v2/pages/common/cost-effective-options.png',
        alt: 'Easy Booking'
      }
    },
    {
      id: 2,
      title: 'Efficient Pickup',
      description:
        "We provide door-to-door pickup for hassle-free international luggage shipment. We'll collect your bags directly from your home or office.",
      image: {
        src: '/images/v2/pages/common/easy-booking-tracking.png',
        alt: 'Efficient Pickup'
      }
    },
    {
      id: 3,
      title: 'Fast Delivery',
      description:
        "We guarantee quick delivery to over 220 countries worldwide, ensuring that your luggage arrives on time, whether you're traveling for business or pleasure.",
      image: {
        src: '/images/v2/pages/common/express-delivery-options.png',
        alt: 'Fast Delivery'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable International Luggage Shipping',
  description:
    'Enjoy cost-effective shipping rates, with savings of up to 70%, on all international luggage shipments. Whether you are moving to a new country, traveling for a holiday, or sending items to family or friends abroad, we ensure your luggage is shipped securely at a competitive price.',
  image: {
    src: '/images/v2/pages/landing-pages/international-luggage-shipping/affordable-international-luggage-shipping.jpg',
    alt: 'Affordable International Luggage Shipping'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of International Luggage Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Convenient Door-to-Door Pickup',
      description:
        'We provide door-to-door pickup service, so you don’t need to worry about transporting your luggage to a shipping location. Relax while we handle everything for you.',
      image: {
        src: '/images/v2/pages/common/convenient-door-to-door-pickup.png',
        alt: 'Convenient Door-to-Door Pickup'
      }
    },
    {
      id: 2,
      title: 'Track Your Luggage',
      description:
        'Stay informed with real-time tracking of your international luggage shipment. Monitor the progress of your luggage every step of the way, giving you peace of mind.',
      image: {
        src: '/images/v2/pages/common/real-time-tracking.png',
        alt: 'Track Your Luggage'
      }
    },
    {
      id: 3,
      title: 'Free Storage for Up to 6 Months',
      description:
        'Need to store your luggage for a while? We offer six months of free storage with our international luggage shipping services, giving you extra flexibility for your travels or relocation.',
      image: {
        src: '/images/v2/pages/common/zero-cost.png',
        alt: 'Free Storage for Up to 6 Months'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for International Luggage Shipping?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Travelers:',
          description: 'Ship your personal luggage ahead to avoid carrying heavy bags during your trip.'
        },
        {
          id: 2,
          title: 'Students:',
          description: 'Ship your belongings and essentials safely to and from your international study destinations.'
        },
        {
          id: 3,
          title: 'Families:',
          description: 'Relocate with ease by shipping family luggage, moving boxes, and more.'
        },
        {
          id: 4,
          title: 'Businesses:',
          description:
            'Send items like trade show materials, promotional products, or other business essentials internationally.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/international-luggage-shipping/who-should-choose-us-for-international-luggage-shipping.jpg',
        alt: 'Who Should Choose Us for International Luggage Shipping?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Shipping Services',
  description:
    'ShipAndStorage offers a wide range of international shipping options to meet your unique needs. Explore our specialized services below:',

  cards: [
    {
      id: 1,
      title: 'Luggage Shipping',
      description:
        'Ship your personal luggage anywhere in the world, with the assurance that your belongings will be handled with care and delivered securely and on time.',
      image: {
        src: '/images/v2/pages/common/luggage-shipping-services.png',
        alt: 'Luggage Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Golf Club Shipping',
      description:
        'Don’t leave your golf clubs behind. Ship them safely with our specialized golf club shipping service, designed to handle your expensive and delicate gear.',
      image: {
        src: '/images/v2/pages/common/Golf-Club-Shipping.png',
        alt: 'Golf Club Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Moving Box Shipping',
      description:
        'Moving abroad? Send your boxes, clothes, and household goods via our affordable and fast international moving box shipping service.',
      image: {
        src: '/images/v2/pages/common/specialty-item-shipping.png',
        alt: 'Moving Box Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Ski and Snowboard Shipping',
      description:
        'Travel with peace of mind knowing your ski and snowboard gear will be securely shipped internationally for your winter adventures.',
      image: {
        src: '/images/v2/pages/common/sports-equipment-storage.png',
        alt: 'Ski and Snowboard Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for International Luggage Shipping?',

  image: {
    url: '/images/v2/pages/landing-pages/international-luggage-shipping/why-choose-shipandstorage-for-international-luggage-shipping.jpg',
    alt: 'Why Choose ShipAndStorage for International Luggage Shipping?'
  },

  articles: [
    {
      id: 1,
      title: 'Fast and Reliable Service',
      description:
        "We provide timely deliveries, with real-time tracking to keep you updated on your luggage's journey."
    },
    {
      id: 2,
      title: 'Six Months’ Free Storage',
      description: 'Store your luggage or items for up to six months at no additional cost.'
    },
    {
      id: 3,
      title: 'Global Reach',
      description: 'With delivery to over 220 destinations worldwide, we ensure your luggage can be shipped anywhere.'
    },
    {
      id: 4,
      title: 'Flexible Shipping Options',
      description:
        "Choose from a variety of options to fit your needs, whether you're shipping one suitcase or multiple boxes."
    },
    {
      id: 5,
      title: 'Affordable Rates',
      description: 'Save up to 70% on international luggage shipping costs compared to traditional courier services.'
    },
    {
      id: 6,
      title: 'Excellent Customer Support',
      description:
        'Our friendly customer service team is available to assist you at every stage of the shipping process.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Secure International Luggage Shipping Solutions Available',
  description:
    'International luggage shipping services are available. Fast, secure, and affordable options for shipping your luggage internationally.',
  image: {
    src: '/images/v2/pages/landing-pages/international-luggage-shipping/secure-international-luggage-shipping-solutions-available.png',
    alt: 'Secure International Luggage Shipping Solutions Available'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description:
    'At ShipAndStorage, we collaborate with top logistics providers to deliver exceptional storage and shipping solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx is a renowned global logistics leader, committed to safely storing and transporting your belongings.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of this information. For more details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers secure and reliable global logistics services, ensuring safe storage and transportation of your items, especially during the busy summer months.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS specializes in secure storage options and comprehensive global shipping solutions, ensuring that your items are handled with care throughout the entire process.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of this information. For more details, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
